import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import { FormCheckbox } from "@components/inputs/form/FormCheckbox/FormCheckbox";
import { Link } from "@components/Link/Link";

type TFormAgreementInputProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  termsOfServiceAcceptedName?: TName;
  marketingRulesAcceptedName?: TName;
  control?: Control<TFieldValues>;
  onMarketingRulesCheckboxClick?: (checked: boolean) => void;
  isMarketingRulesCheckboxLoading?: boolean;
};

export const FormAgreementInput = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  termsOfServiceAcceptedName,
  marketingRulesAcceptedName,
  control,
  onMarketingRulesCheckboxClick,
  isMarketingRulesCheckboxLoading,
}: TFormAgreementInputProps<TFieldValues, TName>) => {
  const { t } = useTranslation();

  const getLabel = (field: "terms" | "marketingRules") => (
    <Trans
      i18nKey={`formAgreementInput.fields.${field}.label`}
      components={{
        href: (
          <Link
            to={t(`formAgreementInput.fields.${field}.link`)}
            target="__blank"
          />
        ),
        href2: (
          <Link
            to={t(`formAgreementInput.fields.${field}.link2`)}
            target="__blank"
          />
        ),
      }}
    />
  );

  return (
    <>
      {termsOfServiceAcceptedName && (
        <FormCheckbox
          name={termsOfServiceAcceptedName}
          label={getLabel("terms")}
          rules={{ required: true }}
          control={control}
        />
      )}
      {marketingRulesAcceptedName && (
        <FormCheckbox
          name={marketingRulesAcceptedName}
          label={getLabel("marketingRules")}
          rules={{ required: true }}
          control={control}
          onClick={(e) => {
            if ("checked" in e.target) {
              // @ts-expect-error - c
              onMarketingRulesCheckboxClick?.(e.target.checked);
            }
          }}
          isLoading={isMarketingRulesCheckboxLoading}
        />
      )}
    </>
  );
};
